import React from "react";
import styled from 'styled-components';

export default class geraeusche extends React.Component {
    render() {
        return(
<div>

    
            <ImageModal src={require('../../../assets/img/geraeuscheinfo_' + document.getElementById('root').dataset.locale + '.jpg')} alt="" title="">
            </ImageModal>

   

</div>
);
    }
}
const OneRow = styled.div`
clear:left;
`;
const TwoRow = styled.div`

`;
const RowSpace = styled.div`
margin:1%;
margin-top:2rem;
color:black;
float:left;
width:30%;
padding:1%;
`;
const ImageModal= styled.img`
max-width: 100%;
padding:auto;
margin:2% !important;
display: flex;
height: auto;
`;
